import React from "react";

const Img = ({ className = "", src = "/images/close.png", alt = "closeImg", ...restProps }) => {
    return (
        <img className={className} src={src} alt={alt} {...restProps} loading={"lazy"} />
    );
};

export { Img };